import { useEffect, useState } from "react";
import { getConfig } from "@/config";

/** Current time, re-read every `intervalMs` (drives moving chart axes and "x ago" labels). */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

export function useDebounced<T>(value: T, ms = 300): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setV(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return v;
}

/** react-query refetchInterval from runtime config (false = disabled). */
export function refetchInterval(): number | false {
  const ms = getConfig().refetchIntervalMs;
  return ms > 0 ? ms : false;
}
